
import GuiThemesTableItem from './GuiThemesTableItem'

import './GuiThemesTable.scss'
import { GuiSettingsDto } from '../../../../../../../../dtos';
import {useState} from "react";

interface IGuiThemesTable {
    items: GuiSettingsDto[];
    onEdit: (rowIndex: number, dto: GuiSettingsDto) => void
    onDelete: (rowIndex: number, dto: GuiSettingsDto) => void
}

const GuiThemesTable: React.FC<IGuiThemesTable> = (props) => {
    // const items = [];
    const [isCloseMenu, setIsCloseMenu] = useState(true);
    const items = props.items.map((item: GuiSettingsDto, index) => {
        return <GuiThemesTableItem
            key={item.gusRecId}
            rowIndex={index + 1}
            dto={item}
            onEdit={props.onEdit}
            onDelete={props.onDelete}
            isCloseMenu={isCloseMenu}
            setIsCloseMenu={setIsCloseMenu}
        />

    })

    const onScroll = () => {
        setIsCloseMenu(true);
    }
    return (
        <div className="gui_themes_table" onScroll={onScroll}>
            <table className="table">
                <thead>
                <tr>
                    <th style={{width: '160px'}}>Brand</th>
                    <th style={{width: '224px'}}>Logo</th>
                    <th style={{width: '50px'}}>Color</th>
                    <th style={{width: '200px'}}>Font</th>
                    <th style={{width: '50px'}}>Background</th>
                    <th style={{width: '70px'}}>Icon</th>
                    <th></th>
                </tr>
                </thead>
                
                <tbody>{ items }</tbody>
            </table>
        </div>
    )
}

export default GuiThemesTable